import * as K from './SalesConstants';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import auth from '../../../libCustom/auth';

export const init = {
  loading: true,
  loaded: false,
  search: '',
  data: [],
  searchData: null,
  clientId: '',
  clientDefault: {},
  assignedTo: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
  table: {
    page: 0,
    sorted: [],
    filtered: [],
    pageSize: undefined,
  },
  salesInformation: {
    clientId: '',
    statusId: 'VTA',
    userId: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
    destination: '',
    departureDate: new Date().toISOString().slice(0, 10),
    returnDate: new Date().toISOString().slice(0, 10),
    interest: '',
    adults: '',
    juniors: '',
    kids: '',
    notes: '',
    assignedTo: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
    executive: auth.getCurrentUser() !== null ? auth.getCurrentUser() : '',
    down: false,
    status: 'leats',
    forcedSale: false,
    limitDate: '',
  },
  commissions: {
    comision: 0,
  },
  flights: [],
  receipts: [],
  otherServicesSale: [],
  packages: [],
  operatorsPaymentSale: [],
  operatorsPaiyedSale: [],
  lodgings: [],
  balance: {
    totalPrice: '',
    totalBuyPrice: '',
    totalReceipt: '',
    totalDebit: '',
    payForm: '',
    totalPayForm: '',
    utility: '',
    commissionsPercent: 10,
    commissions: '',
    netProfit: '',
    totalOperatorPayed: '',
  },
  dataToEdit: {
    flight: {},
    otherServices: {},
    lodging: {},
    receipt: {},
    packages: {},
  },
  indexToEdit: '',
  modalAddStatus: {
    flight: false,
    otherServices: false,
    receipt: false,
  },
  files: [],
  filesInvoice: [],
  client: {},
  optionsSelect: {
    clients: [],
  },
  delete: false,
};

export default function reducer(state = init, action) {
  switch (action.type) {
    case K.SETSTATE: {
      return action.payload;
    }

    case K.STATEINIT: {
      return init;
    }

    case K.ON_CHANGE: {
      return immutable.set(state, action.payload.path, action.payload.value);
    }

    case K.ADD_SERVICE: {
      return immutable.push(state, ['otherServicesSale'], action.payload);
    }

    case K.UPDATE_SERVICE: {
      return immutable.set(
        state,
        ['otherServicesSale', action.payload.data.index],
        action.payload.data.value
      );
    }

    case K.ADD_PACKAGE: {
      return immutable.push(state, ['packages'], action.payload);
    }

    case K.UPDATE_PACKAGE: {
      return immutable.set(
        state,
        ['packages', action.payload.data.index],
        action.payload.data.value
      );
    }

    case K.ADD_OPERATORSPAYMENTS: {
      return immutable.push(state, ['operatorsPaymentSale'], action.payload);
    }

    case K.UPDATE_OPERATORSPAYMENTS: {
      let newState = immutable.set(
        state,
        ['operatorsPaymentSale', action.payload.data.index],
        action.payload.data.value
      );

      let totalPayed = 0;
      newState.operatorsPaymentSale.map(function (pay) {
        if (pay.totalPayed !== undefined) {
          totalPayed = totalPayed + Number(pay.totalPayed);
        }
      });

      //TODO Toño - Revisar por que a algunos aunque colocan todo el total no les actualiza la palomita verde.

      newState = immutable.set(
        newState,
        ['balance', 'totalOperatorPayed'],
        totalPayed
      );

      return newState;
    }

    case K.ADD_FLIGHT: {
      return immutable.push(state, ['flights'], action.payload);
    }

    case K.UPDATE_FLIGHT: {
      return immutable.set(
        state,
        ['flights', action.payload.data.index],
        action.payload.data.value
      );
    }

    case K.ADD_LODGING: {
      return immutable.push(state, ['lodgings'], action.payload);
    }

    case K.ADD_RECEIPT: {
      return immutable.push(state, ['receipts'], action.payload);
    }

    case K.UPDATE_RECEIPT: {
      return immutable.set(
        state,
        ['receipts', action.payload.data.index],
        action.payload.data.value
      );
    }

    case K.OPEN_MODAL_ADD: {
      return immutable.set(state, ['modalAddStatus', action.payload], true);
    }

    case K.CLOSE_MODAL_ADD: {
      var newState = immutable.set(
        state,
        ['modalAddStatus', action.payload],
        false
      );
      newState = immutable.set(newState, ['dataToEdit', action.payload], {});
      return newState;
    }

    case K.UPDATE_LODGING: {
      return immutable.set(
        state,
        ['lodgings', action.payload.data.index],
        action.payload.data.value
      );
    }

    case K.FIND + '_PENDING': {
      return { ...state, loading: true };
    }

    case K.FIND + '_FULFILLED': {
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        formData: {},
      };
    }

    case K.FIND + '_REJECTED': {
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [],
        formData: {},
        error: action.payload,
      };
    }

    //GET CLIENT

    case K.FIND_BY_ID + '_PENDING': {
      return { ...state, loading: true };
    }

    case K.FIND_BY_ID + '_FULFILLED': {
      return {
        ...state,
        loading: false,
        loaded: true,
        formData: action.payload,
      };
    }

    case K.FIND_BY_ID + '_REJECTED': {
      return {
        ...state,
        loading: false,
        loaded: false,
        formData: init.formData,
        error: action.payload,
      };
    }

    //CREATE

    case K.CREATE + '_PENDING': {
      return { ...state, loading: true };
    }

    case K.CREATE + '_FULFILLED': {
      return {
        ...state,
        search: '',
        loading: false,
        loaded: true,
        formData: init.formData,
        openForm: false,
      };
    }

    case K.CREATE + '_REJECTED': {
      return {
        ...state,
        loading: false,
        loaded: false,
        formData: init.formData,
        error: action.payload,
      };
    }

    //UPADTE

    case K.UPDATE + '_PENDING': {
      return { ...state, loading: true, formData: action.payload };
    }

    case K.UPDATE + '_FULFILLED': {
      return {
        ...state,
        loading: false,
        loaded: true,
        formData: init.formData,
      };
    }

    case K.UPDATE + '_REJECTED': {
      return {
        ...state,
        loading: false,
        loaded: false,
        formData: init.formData,
        error: action.payload,
      };
    }

    //DELETE

    case K.DELETE + '_PENDING': {
      return { ...state, loading: true };
    }

    case K.DELETE + '_FULFILLED': {
      return {
        ...state,
        loading: false,
        loaded: true,
        formData: init.formData,
      };
    }

    case K.DELETE + '_REJECTED': {
      return {
        ...state,
        loading: false,
        loaded: false,
        formData: init.formData,
        error: action.payload,
      };
    }

    case K.CHANGE_TABLE: {
      return {
        ...state,
        table: {
          ...state.table,
          [action.payload.feature]: action.payload.value,
        },
      };
    }

    case K.SEARCH_TABLE: {
      return {
        ...state,
        searchData:
          action.payload.search !== '' ? action.payload.searchData : null,
        search: action.payload.search,
      };
    }

    default:
      /* code */
      break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/views/Sales/redux/SalesReducers.jsx